import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTasks} from '@fortawesome/free-solid-svg-icons';
const Projects = () =>{
	return (
		<div className="pb-5">
		  	<p className="py-2 pr-2">
		  		<span className="titleLogo"><FontAwesomeIcon className="fa-2x pt-2" icon={faTasks} /></span>
		  		<span className="titleProject pl-3">Projects</span>
		  	</p>
		  	<div className="row pt-4 pl-4">
		  		<div className="col-md-4 companySection">
		  			<h5 className="headings">Weather App</h5>
		  		</div>
		  		<div className="col-md-8">
		  			<section>
			  			<h5 className="headings">Project Description</h5>
			  			<p>This is a PWA App Built with React-Js, main motto of this project is to
			  			   get the current Location by the Longitude and 
			  			   show the current weather, hourly weather broadcast of 24 Hrs, and Daily weather broadcast 
			  			   of 7 days. this project is deployed in Netlify  	
			  			</p>
			  			<a href="https://silly-lichterman-5b9330.netlify.app/" target="_blank" rel="noreferrer">
			  			<button className="btn btn-sm btn-success">
				  			Weather app
			  			</button></a>
		  			</section>
  				</div>
	  		</div>
	  		<hr/>
	  		<div className="row pt-4 pl-4">
		  		<div className="col-md-4 companySection">
		  			<h5 className="headings">News App</h5>
		  		</div>
		  		<div className="col-md-8">
		  			<section>
			  			<h5 className="headings">Project Description</h5>
			  			<p>This is a PWA App Built with React-Js, in This app we have several news topics
			  			   and more then 2 languages. this project is deployed in Netlify  	
			  			</p>
			  			<a href="https://happy-wilson-df54ae.netlify.app/" target="_blank" rel="noreferrer">
			  			<button className="btn btn-sm btn-success">
				  			News app
			  			</button></a>
		  			</section>
  				</div>
	  		</div>
	  		<hr/>
	  		<div className="row pt-4 pl-4">
		  		<div className="col-md-4 companySection">
		  			<h5 className="headings">Github Repos</h5>
		  		</div>
		  		<div className="col-md-8">
		  			<section>
			  			<h5 className="headings">Project Description</h5>
			  			<p>This React app is used to fetch the User repositories from the Github by entering his Repository Name.
			  			   Main concept in this project is it include Dark and Day mode
			  			</p>
			  			<a href="https://designerprasan007.github.io/react-github-repos/" target="_blank" rel="noreferrer">
			  			<button className="btn btn-sm btn-success">
				  			Github Repos
			  			</button></a>
		  			</section>
  				</div>
	  		</div>
	  		<hr/>
	  		<div className="row pt-4 pl-4">
		  		<div className="col-md-4 companySection">
		  			<h5 className="headings">Chat up</h5>
		  		</div>
		  		<div className="col-md-8">
		  			<section>
			  			<h5 className="headings">Project Description</h5>
			  			<p>This is clone of WhatsApp written in MERN-stack, it includes Socket-io for messages
			  				Peer-js for video and audio call, in this project React, redux, thunk and redux 
			  				Store are used for Client side management, Nodejs and Express are used for Backend.
			  				and used Mongo as the database
			  			</p>
			  			<a href="https://github.com/designerprasan007/MERN-chatUP" target="_blank" rel="noreferrer">
			  			<button className="btn btn-sm btn-success">
				  			Chat-Up
			  			</button></a>
		  			</section>
  				</div>
	  		</div>
			  <hr/>
			<div className="row pt-4 pl-4">
		  		<div className="col-md-4 companySection">
		  			<h5 className="headings">Typing Speed</h5>
		  		</div>
		  		<div className="col-md-8">
		  			<section>
			  			<h5 className="headings">Project Description</h5>
			  			<p>This Project is written in React to test the typing speed, this is hosted in the Netlify hosting server</p>
			  			<a href="https://optimistic-leavitt-52d318.netlify.app/" target="_blank" rel="noreferrer">
			  			<button className="btn btn-sm btn-success">
						  Typing Speed
			  			</button></a>
		  			</section>
  				</div>
	  		</div>
			<hr/>
			<div className="row pt-4 pl-4">
		  		<div className="col-md-4 companySection">
		  			<h5 className="headings">Smart Calculator</h5>
		  		</div>
		  		<div className="col-md-8">
		  			<section>
			  			<h5 className="headings">Project Description</h5>
			  			<p>This is basic React Calculator PWA app with the voice recognition for hand free calculation</p>
			  			<a href="https://beamish-fox-bc86e0.netlify.app/" target="_blank" rel="noreferrer">
			  			<button className="btn btn-sm btn-success">
						  Smart Calculator
			  			</button></a>
		  			</section>
  				</div>
	  		</div>
		</div>  	
		)
}

export default Projects;